var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.5C6.11929 7.5 5 8.61929 5 10V32.5C5 33.8807 6.11929 35 7.5 35H32.5C33.8807 35 35 33.8807 35 32.5V10C35 8.61929 33.8807 7.5 32.5 7.5H7.5ZM2.5 10C2.5 7.23858 4.73858 5 7.5 5H32.5C35.2614 5 37.5 7.23858 37.5 10V32.5C37.5 35.2614 35.2614 37.5 32.5 37.5H7.5C4.73858 37.5 2.5 35.2614 2.5 32.5V10Z",
    fill: "#08152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 20C24.1605 20 25 19.1605 25 18.125C25 17.0895 24.1605 16.25 23.125 16.25C22.0895 16.25 21.25 17.0895 21.25 18.125C21.25 19.1605 22.0895 20 23.125 20Z",
    fill: "#08152C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 20C30.4105 20 31.25 19.1605 31.25 18.125C31.25 17.0895 30.4105 16.25 29.375 16.25C28.3395 16.25 27.5 17.0895 27.5 18.125C27.5 19.1605 28.3395 20 29.375 20Z",
    fill: "#08152C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 26.25C24.1605 26.25 25 25.4105 25 24.375C25 23.3395 24.1605 22.5 23.125 22.5C22.0895 22.5 21.25 23.3395 21.25 24.375C21.25 25.4105 22.0895 26.25 23.125 26.25Z",
    fill: "#08152C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 26.25C30.4105 26.25 31.25 25.4105 31.25 24.375C31.25 23.3395 30.4105 22.5 29.375 22.5C28.3395 22.5 27.5 23.3395 27.5 24.375C27.5 25.4105 28.3395 26.25 29.375 26.25Z",
    fill: "#08152C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 26.25C11.6605 26.25 12.5 25.4105 12.5 24.375C12.5 23.3395 11.6605 22.5 10.625 22.5C9.58947 22.5 8.75 23.3395 8.75 24.375C8.75 25.4105 9.58947 26.25 10.625 26.25Z",
    fill: "#08152C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 26.25C17.9105 26.25 18.75 25.4105 18.75 24.375C18.75 23.3395 17.9105 22.5 16.875 22.5C15.8395 22.5 15 23.3395 15 24.375C15 25.4105 15.8395 26.25 16.875 26.25Z",
    fill: "#08152C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 32.5C11.6605 32.5 12.5 31.6605 12.5 30.625C12.5 29.5895 11.6605 28.75 10.625 28.75C9.58947 28.75 8.75 29.5895 8.75 30.625C8.75 31.6605 9.58947 32.5 10.625 32.5Z",
    fill: "#08152C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 32.5C17.9105 32.5 18.75 31.6605 18.75 30.625C18.75 29.5895 17.9105 28.75 16.875 28.75C15.8395 28.75 15 29.5895 15 30.625C15 31.6605 15.8395 32.5 16.875 32.5Z",
    fill: "#08152C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 32.5C24.1605 32.5 25 31.6605 25 30.625C25 29.5895 24.1605 28.75 23.125 28.75C22.0895 28.75 21.25 29.5895 21.25 30.625C21.25 31.6605 22.0895 32.5 23.125 32.5Z",
    fill: "#08152C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C10.6904 2.5 11.25 3.05964 11.25 3.75V6.25C11.25 6.94036 10.6904 7.5 10 7.5C9.30964 7.5 8.75 6.94036 8.75 6.25V3.75C8.75 3.05964 9.30964 2.5 10 2.5ZM30 2.5C30.6904 2.5 31.25 3.05964 31.25 3.75V6.25C31.25 6.94036 30.6904 7.5 30 7.5C29.3096 7.5 28.75 6.94036 28.75 6.25V3.75C28.75 3.05964 29.3096 2.5 30 2.5Z",
    fill: "#08152C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 11.25H36.25V13.75H3.75V11.25Z",
    fill: "#08152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutline);
export default __webpack_public_path__ + "static/media/calendar-outline.eb1666f3407d10dd05092a0f66ada298.svg";
export { ForwardRef as ReactComponent };